module.exports = __webpack_public_path__ + "img/logo1 (27).ce2d20e4.jpg";